import React from 'react';
import ProfileSelector from '../components/ProfileSelector';
import { useNavigate } from 'react-router-dom';

const ProfileSelectPage = () => {
  const navigate = useNavigate();
  
  const handleProfileSelected = (profile) => {
    navigate('/dashboard');
  };

  return <ProfileSelector onSelectProfile={handleProfileSelected} showBackButton={true} />;
};

export default ProfileSelectPage;
